import { render } from "./SellerInvoices.vue?vue&type=template&id=60d10b11"
import script from "./SellerInvoices.vue?vue&type=script&lang=js"
export * from "./SellerInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/home/oliver/Development/auction-system/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__